import useSWRImmutable from 'swr/immutable'
import { FeeType } from '@cinch-labs/logistics-fees-types'
import { getFeeTypes } from '../api/fee-types'

export interface FeeTypesResponse {
  data?: FeeType[]
  isLoading: boolean
  error?: Error
}

export const useFeeTypes = (): FeeTypesResponse => {
  const { data, error, isLoading } = useSWRImmutable<FeeType[], Error>(
    'fee-types',
    getFeeTypes,
    { errorRetryCount: 1 },
  )

  return { data, isLoading, error }
}
